/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_DescriptionInputs */

const en_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const fr_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const it_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const ru_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const es_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const zh_cn2_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const ja_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const hi_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const pt_pt2_explorer_info_property_description = /** @type {(inputs: Explorer_Info_Property_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Explorer_Info_Property_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_description = /** @type {((inputs?: Explorer_Info_Property_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_description(inputs)
	if (locale === "de") return de_explorer_info_property_description(inputs)
	if (locale === "it") return it_explorer_info_property_description(inputs)
	if (locale === "ru") return ru_explorer_info_property_description(inputs)
	if (locale === "es") return es_explorer_info_property_description(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_description(inputs)
	if (locale === "ja") return ja_explorer_info_property_description(inputs)
	if (locale === "hi") return hi_explorer_info_property_description(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_description(inputs)
	return en_explorer_info_property_description(inputs)
});